// import { useMemo } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import {
//   useGetCourseBySlugQuery,
//   useGetCourseResultQuery,
// } from "@/features/api/courseApi";

// import {
//   User,
//   Award,
//   CheckCircle2,
//   History,
//   Loader2,
//   BarChart3,
//   Trophy,
// } from "lucide-react";

// export default function CourseResult() {
// const { slug } = useParams();
// const navigate = useNavigate();

//   /* ================= COURSE ================= */
//   const { data: courseRes, isLoading: courseLoading } =
//     useGetCourseBySlugQuery(slug, { skip: !slug });

//   const course = courseRes?.course;

//   /* ================= RESULT ================= */
//   const {
//     data: rawResult,
//     isLoading: resultLoading,
//     error,
//   } = useGetCourseResultQuery(course?._id, {
//     skip: !course?._id,
//     refetchOnMountOrArgChange: true,
//   });

//   /* ================= NORMALIZE BACKEND ================= */
//   const { results, user } = useMemo(() => {
//     if (!rawResult) return { results: [], user: {} };

//     // handle multiple backend shapes safely
//     if (rawResult.results) {
//       return {
//         results: rawResult.results,
//         user: rawResult.user || {},
//       };
//     }

//     if (rawResult.data?.results) {
//       return {
//         results: rawResult.data.results,
//         user: rawResult.data.user || {},
//       };
//     }

//     return { results: [], user: {} };
//   }, [rawResult]);

//   /* ================= LOADING ================= */
//   if (courseLoading || resultLoading) {
//     return (
//       <div className="flex items-center justify-center min-h-screen">
//         <Loader2 className="animate-spin mr-2" /> Loading results...
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="min-h-screen flex items-center justify-center text-red-600">
//         Failed to load results
//       </div>
//     );
//   }

//   if (!results.length) {
//     return (
//       <div className="min-h-screen flex items-center justify-center">
//         No attempts yet.
//       </div>
//     );
//   }

//   /* ================= CALCULATIONS ================= */
// const attempts = results.length;
// const percentages = results.map(r => Number(r.score || 0));

// const bestPercentage = percentages.length ? Math.max(...percentages) : 0;

// const avgPercentage = percentages.length
//   ? Math.round(percentages.reduce((a,b)=>a+b,0)/percentages.length)
//   : 0;

// const latest = results[results.length - 1];
// const latestPct = Number(latest?.score || 0);

// const passed = latestPct >= 30;

//   const handleRetake = () =>
// navigate(`/courses/${course?.slug}/learn`);
//   /* ================= UI ================= */
//   return (
//     <div className="min-h-screen bg-gray-50 py-10 px-4">
//       <div className="max-w-5xl mx-auto space-y-8">

//         <div className="text-center">
//         <h1 className="text-3xl font-bold">{course?.title}</h1>
//           <p className="text-gray-500">Course Result Summary</p>
//         </div>

//         <div className="grid md:grid-cols-4 gap-4">
//           <Stat icon={Trophy} label="Best %" value={`${bestPercentage}%`} />
//           <Stat icon={BarChart3} label="Average %" value={`${avgPercentage}%`} />
//           <Stat icon={History} label="Attempts" value={attempts} />
//           <Stat icon={Award} label="Latest %" value={`${latestPct}%`} />
//         </div>

//         <Section title="Student Information" icon={User}>
//           <Info label="Name" value={user.name || "—"} />
//           <Info label="Email" value={user.email || "—"} />
//         </Section>

//         <Section title="Latest Attempt" icon={Award}>

//           <Info label="Percentage" value={`${latestPct}%`} />

//           <Info
//             label="Status"
//             value={
//               <span
//                 className={
//                   passed
//                     ? "text-green-600 font-semibold"
//                     : "text-red-600 font-semibold"
//                 }
//               >
//                 {passed ? "Passed" : "Failed"}
//               </span>
//             }
//           />

//           <button
//             onClick={handleRetake}
//             className="mt-4 flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded"
//           >
//             <CheckCircle2 size={16} /> Retake Course
//           </button>
//         </Section>

//         <Section title="Attempt History" icon={History}>
//           <table className="w-full text-sm">
//             <thead>
//               <tr className="border-b">
//                 <th>#</th>
//                 <th>Score</th>
//                 <th>%</th>
//                 <th>Status</th>
//               </tr>
//             </thead>

//             <tbody>
//               {results.map((r, i) => {
                
//                 const total =
//                 r.totalQuestions ||
//                 r.total ||
//                 r.questionsCount ||
//                 100;
                
//                 const pct = Number(r.score || 0);

//                   return (
//                     <tr key={i} className="border-b text-center">
//                     <td>{i + 1}</td>
//                     <td>{r.score}/{total}</td>
//                     <td>{pct}%</td>
//                     <td className={pct >= 30 ? "text-green-600" : "text-red-600"}>
//                       {pct >= 30 ? "Passed" : "Failed"}
//                     </td>
//                   </tr>
//                   );
//               })}
//             </tbody>
//           </table>
//         </Section>
//       </div>
//     </div>
//   );
// }

// /* ================= HELPERS ================= */

// function Stat({ icon: Icon, label, value }) {
//   return (
//     <div className="bg-white rounded-lg shadow p-4 text-center">
//       <Icon className="mx-auto text-blue-600 mb-2" />
//       <p className="text-sm text-gray-500">{label}</p>
//       <p className="text-2xl font-bold">{value}</p>
//     </div>
//   );
// }

// function Section({ title, icon: Icon, children }) {
//   return (
//     <div className="bg-white shadow rounded-lg p-6 space-y-4">
//       <h2 className="flex items-center gap-2 text-xl font-semibold">
//         <Icon size={20} className="text-blue-600" />
//         {title}
//       </h2>
//       <div className="grid sm:grid-cols-2 gap-4">{children}</div>
//     </div>
//   );
// }

// function Info({ label, value }) {
//   return (
//     <p>
//       <strong>{label}:</strong> {value}
//     </p>
//   );
// }





import { useMemo, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

import {
  useGetCourseBySlugQuery,
  useGetCourseResultQuery,
} from "@/features/api/courseApi";

import {
  User,
  Award,
  CheckCircle2,
  History,
  Loader2,
  BarChart3,
  Trophy,
  TrendingUp,
  AlertTriangle,
  Clock,
  RotateCcw
} from "lucide-react";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

/* ================= COMPONENT ================= */

export default function CourseResult() {
  const { slug } = useParams();
  const navigate = useNavigate();

  /* ================= COURSE ================= */

  const {
    data: courseRes,
    isLoading: courseLoading,
    error: courseError,
  } = useGetCourseBySlugQuery(slug, { skip: !slug });

  const course = courseRes?.course;

  // ✅ FIXED POSITION
  const PASS_PERCENT = course?.passPercentage || 30;

  /* ================= RESULT ================= */

  const {
    data: rawResult,
    isLoading: resultLoading,
    error: resultError,
  } = useGetCourseResultQuery(course?._id, {
    skip: !course?._id,
    refetchOnMountOrArgChange: true,
  });

  /* ================= NORMALIZE ================= */

  const { results, user } = useMemo(() => {
    if (!rawResult) return { results: [], user: {} };

    try {
      if (rawResult.progress) {
        const lessons = rawResult.progress.lessonsProgress || [];

        return {
          results: lessons.map((lp, i) => ({
            _id: lp.lessonId || i,
            scorePercent: Number(lp?.score ?? 0),
            lessonId: lp.lessonId,
          })),
          user: rawResult.progress.user || {},
        };
      }

      if (Array.isArray(rawResult.results)) {
        return { results: rawResult.results, user: rawResult.user || {} };
      }

    } catch (e) {
      console.error(e);
    }

    return { results: [], user: {} };
  }, [rawResult]);

  /* ================= STATS ================= */

  const stats = useMemo(() => {
    if (!results.length) {
      return { attempts: 0, best: 0, avg: 0, latest: 0, passed: false };
    }

    const arr = results.map(r => Number(r.scorePercent || 0));

    const attempts = arr.length;
    const best = Math.max(...arr);
    const avg = Math.round(arr.reduce((a, b) => a + b, 0) / attempts);
    const latest = arr[arr.length - 1];

    return {
      attempts,
      best,
      avg,
      latest,
      passed: latest >= PASS_PERCENT,
    };
  }, [results, PASS_PERCENT]);

  /* ================= LESSON MAP ================= */

  const lessonMap = useMemo(() => {
    if (!course?.lessons) return {};
    return Object.fromEntries(
      course.lessons.map(l => [l._id, l.title])
    );
  }, [course]);

  /* ================= GRAPH ================= */

  const chartData = useMemo(() => {
    return results.map((r, i) => ({
      attempt: lessonMap[r.lessonId] || `Lesson ${i + 1}`,
      score: Number(r.scorePercent || 0),
    }));
  }, [results, lessonMap]);

  /* ================= WEAK ================= */

  const weakTopics = useMemo(() => {
    return results
      .filter(r => r.scorePercent < 50)
      .map(r => lessonMap[r.lessonId] || "Lesson")
      .slice(0, 3);
  }, [results, lessonMap]);

  /* ================= TIME ================= */

  const totalTime = useMemo(() => {
    return rawResult?.progress?.lessonsProgress?.reduce(
      (sum, l) => sum + (l.timeSpent || 0),
      0
    ) || 0;
  }, [rawResult]);

  /* ================= INSIGHTS ================= */

  const insights = useMemo(() => {
    const msg = [];

    if (stats.latest < PASS_PERCENT) {
      msg.push("You need improvement to pass.");
    }

    if (stats.avg < 50) {
      msg.push("Focus on fundamentals.");
    }

    if (!msg.length) {
      msg.push("Great performance 🚀");
    }

    return msg;
  }, [stats, PASS_PERCENT]);

  /* ================= STATES ================= */

  if (courseLoading || resultLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="animate-spin mr-2" />
        Loading...
      </div>
    );
  }

  if (courseError || resultError) {
    return <div className="text-center text-red-600 py-20">Error loading</div>;
  }

  if (!course) {
    return <div className="text-center py-20">Course not found</div>;
  }

  if (!results.length) {
    return (
      <div className="text-center py-20">
        <p className="mb-4">No results yet</p>
        <button
          onClick={() => navigate(`/courses/${slug}/learn`)}
          className="bg-blue-600 text-white px-6 py-2 rounded"
        >
          Start Learning
        </button>
      </div>
    );
  }

  /* ================= UI ================= */

  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4">
      <div className="max-w-6xl mx-auto space-y-8">

        <h1 className="text-3xl font-bold text-center">
          {course.title}
        </h1>

        {/* STATS */}
        <div className="grid md:grid-cols-5 gap-4">
          <Stat icon={Trophy} label="Best" value={`${stats.best}%`} />
          <Stat icon={BarChart3} label="Average" value={`${stats.avg}%`} />
          <Stat icon={History} label="Lessons" value={stats.attempts} />
          <Stat icon={Award} label="Latest" value={`${stats.latest}%`} />
          <Stat icon={Clock} label="Time" value={`${Math.floor(totalTime / 60)}m`} />
        </div>

        {/* GRAPH */}
        <Card title="Progress" icon={TrendingUp}>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="attempt" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="score" strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
        </Card>

        {/* WEAK */}
        <Card title="Weak Areas" icon={AlertTriangle}>
          {weakTopics.length ? weakTopics.map(t => <p key={t}>{t}</p>) : "None 🎉"}
        </Card>

        {/* INSIGHTS */}
        <Card title="Insights" icon={TrendingUp}>
          {insights.map((i, idx) => <p key={idx}>• {i}</p>)}
        </Card>

        {/* USER */}
        <Card title="Student" icon={User}>
          <p>{user?.name}</p>
          <p>{user?.email}</p>
        </Card>

        {/* ACTION */}
        <div className="text-center">
          <button
            onClick={() => navigate(`/courses/${slug}/learn`)}
            className="bg-blue-600 text-white px-6 py-2 rounded flex items-center gap-2 mx-auto"
          >
            <RotateCcw className="w-4 h-4" />
            Retake Course
          </button>
        </div>

      </div>
    </div>
  );
}

/* ================= UI ================= */

function Stat({ icon: Icon, label, value }) {
  return (
    <div className="bg-white p-4 rounded shadow text-center">
      <Icon className="mx-auto mb-2 text-blue-600" />
      <p className="text-sm">{label}</p>
      <p className="text-xl font-bold">{value}</p>
    </div>
  );
}

function Card({ title, icon: Icon, children }) {
  return (
    <div className="bg-white p-6 rounded shadow">
      <h2 className="flex items-center gap-2 font-semibold mb-4">
        <Icon size={18} className="text-blue-600" />
        {title}
      </h2>
      {children}
    </div>
  );
}